import {useSelector} from "react-redux";

let savedLounge;
try {
    savedLounge = JSON.parse(window.localStorage.lounge);
}
catch (e) {}

export default ()=>useSelector(({api})=>api.discoverLounge||savedLounge);
